import { ReactElement } from "react";
import Layout from "../../components/layout";
import NeighborhoodViewAll from "../../components/Neighborhood/NieghborhoodViewAll";

const NeighorhoodViewAllPage = (): ReactElement => {
  return (
    <Layout>
      <NeighborhoodViewAll />
    </Layout>
  );
};

export default NeighorhoodViewAllPage;
